export const MultiplicityPatterns = [
    { label: 'singlet', value: 's', multiplicity: 1, names: ['br s'] },
    { label: 'doublet', value: 'd', multiplicity: 2, names: [] },
    { label: 'triplet', value: 't', multiplicity: 3, names: [] },
    { label: 'quartet', value: 'q', multiplicity: 4, names: [] },
    {
        label: 'quintet',
        value: 'i',
        multiplicity: 5,
        names: ['quint', 'qui', 'qnt', 'pentet', 'pnt', 'pent'],
    },
    {
        label: 'sextet',
        value: 'h',
        multiplicity: 6,
        names: ['x', 'sxt', 'sext', 'hexuplet'],
    },
    {
        label: 'septet',
        value: 'p',
        multiplicity: 7,
        names: ['sept', 'spt', 'heptet', 'hpt', 'hept'],
    },
    { label: 'octet', value: 'o', multiplicity: 8, names: ['oct'] },
    { label: 'nonet', value: 'n', multiplicity: 9, names: ['non'] },
    { label: 'massive', value: 'm', multiplicity: null, names: [] },
];
//# sourceMappingURL=MultiplicityPatterns.js.map